import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import {
  ReactPlugin,
  withAITracking,
} from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';

import { useEffect } from 'react';
import { configApiRef, useApi } from '@backstage/core-plugin-api';

export const reactPlugin = new ReactPlugin();

const ApplicationInsight = ({ children }) => {
  const config = useApi(configApiRef);
  const AIString = config.getOptionalString('app.appInsight');

  useEffect(() => {
    const browserHistory = createBrowserHistory({ basename: '' });
    const appInsights = new ApplicationInsights({
      config: {
        connectionString: AIString,
        extensions: [reactPlugin],
        extensionConfig: {
          [reactPlugin.identifier]: { history: browserHistory },
        },
        enableAutoRouteTracking: true,
      },
    });
    appInsights.loadAppInsights();
  }, [AIString]);

  return children;
};

export { ApplicationInsight };
